// extracted by mini-css-extract-plugin
module.exports = {"item":"Entry_item__1amUb","icon":"Entry_icon__2Gca2","img":"Entry_img__31ntW","body":"Entry_body__3N-ir"};